import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { eveshamConfig } from "./data";

export default function EveshamPage() {
  return <CityPageTemplate config={eveshamConfig} />;
}